<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size"
    :viewBox="viewBox"
  >
    <g data-name="グループ 9753">
      <path
        data-name="パス 5015"
        d="M663.305 130.017a2.153 2.153 0 0 1-1.111-.309l-8.859-6.243h-5.085a1.282 1.282 0 0 1-1.28-1.282v-6.8a1.281 1.281 0 0 1 1.28-1.28h5.588l8.286-5.893a2.121 2.121 0 0 1 2.292-.047 2.251 2.251 0 0 1 1.08 1.924v17.694a2.251 2.251 0 0 1-1.076 1.922 2.162 2.162 0 0 1-1.115.314zm-14.142-8.747h4.518a1.091 1.091 0 0 1 .632.2l8.97 6.325.017-17.705-.008-.016-8.468 6.024a1.1 1.1 0 0 1-.636.2h-5.024z"
        transform="translate(-645.596 -103.053)"
        :style="{ fill: color }"
      />
      <g data-name="グループ 9269-2">
        <path
          data-name="パス 5016"
          d="M674.955 129.919a1.1 1.1 0 0 1-.832-1.812c.043-.052 2.626-3.2 2.626-9.88s-2.582-9.657-2.607-9.687a1.1 1.1 0 0 1 1.623-1.476c.129.141 3.179 3.557 3.179 11.163 0 7.589-3.031 11.165-3.159 11.313a1.093 1.093 0 0 1-.83.379z"
          transform="translate(-647.901 -102.598)"
          :style="{ fill: color }"
        />
        <path
          data-name="パス 5017"
          d="M671.591 124.8a1.1 1.1 0 0 1-.835-1.808 7.23 7.23 0 0 0 1.139-4.427c0-2.984-1.077-4.27-1.123-4.323a1.106 1.106 0 0 1 .1-1.543 1.091 1.091 0 0 1 1.531.072c.172.188 1.689 1.952 1.689 5.794 0 3.824-1.5 5.66-1.669 5.856a1.1 1.1 0 0 1-.832.379z"
          transform="translate(-647.613 -103.087)"
          :style="{ fill: color }"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'SpeakerOnSVG',
  props: {
    size: {
      type: String,
      default: '32px',
    },
    viewBox: {
      type: String,
      default: '0 0 32 32',
    },
    color: {
      type: String,
      default: '#0075c2',
    },
  },
};
</script>
